import { NgModule } from '@angular/core';
import { ENV_PROD_BUILD } from '@y42/environment';
import { ENABLE_SENTRY } from '../sentry/sentry.module';
import { FullStoryService } from './full-story.service';

export function fullstoryServiceFactory(enableFullStory: boolean, production: boolean): FullStoryService {
  if (enableFullStory) {
    return new FullStoryService(production);
  }

  const service = {} as FullStoryService;
  return service;
}

@NgModule({
  providers: [
    {
      provide: FullStoryService,
      useFactory: fullstoryServiceFactory,
      deps: [ENABLE_SENTRY, ENV_PROD_BUILD],
    },
  ],
})
export class FullStoryModule {}
